import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  activeButton: {
    background: 'white',
    borderRadius: 20,
    border: '2px solid',
    borderColor: '#9a66bf',
    color: 'white',
    height: '40px',
    minWidth: '160px',
  },
  inactiveButton: {
    background: 'white',
    borderRadius: 20,
    border: '2px solid',
    borderColor: '#a9a9a9',
    color: 'white',
    height: '40px',
    minWidth: '160px',
  },
};

const EvaButton = ({ classes, className, children, onClick, active }) => (
  <Button
    className={`${className} ${active ? classes.activeButton : classes.inactiveButton}`}
    disabled={active !== true}
    onClick={onClick}
  >
    {children}
  </Button>
);

EvaButton.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  active: PropTypes.bool,
  className: PropTypes.string,
};

EvaButton.defaultProps = {
  children: 'No title',
  active: true,
  className: '',
};

export default withStyles(styles)(EvaButton);
